import { apiFetch } from './client'
import type {
  AppointmentCreate,
  AppointmentListItem,
  AppointmentRead,
  AppointmentUpdate,
} from '../types/appointments'

export interface ListAppointmentsParams {
  practice_id?: number
  patient_id?: number
  date_from?: string
  date_to?: string
  status?: string
  limit?: number
  offset?: number
}

export async function listAppointments(
  params: ListAppointmentsParams = {},
): Promise<AppointmentListItem[]> {
  const qs = new URLSearchParams()
  if (params.practice_id !== undefined) qs.set('practice_id', String(params.practice_id))
  if (params.patient_id !== undefined) qs.set('patient_id', String(params.patient_id))
  if (params.date_from) qs.set('date_from', params.date_from)
  if (params.date_to) qs.set('date_to', params.date_to)
  if (params.status) qs.set('status', params.status)
  if (params.limit !== undefined) qs.set('limit', String(params.limit))
  if (params.offset !== undefined) qs.set('offset', String(params.offset))
  const res = await apiFetch(`/api/appointments?${qs.toString()}`)
  if (!res.ok) throw new Error('Failed to load appointments')
  return res.json() as Promise<AppointmentListItem[]>
}

export async function getAppointment(id: number): Promise<AppointmentRead> {
  const res = await apiFetch(`/api/appointments/${id}`)
  if (res.status === 404) throw new Error('Appointment not found')
  if (!res.ok) throw new Error('Failed to load appointment')
  return res.json() as Promise<AppointmentRead>
}

export async function createAppointment(data: AppointmentCreate): Promise<AppointmentRead> {
  const res = await apiFetch('/api/appointments', {
    method: 'POST',
    body: JSON.stringify(data),
  })
  if (!res.ok) {
    const err = (await res.json()) as { detail?: string }
    throw new Error(typeof err.detail === 'string' ? err.detail : 'Failed to create appointment')
  }
  return res.json() as Promise<AppointmentRead>
}

export async function updateAppointment(
  id: number,
  data: AppointmentUpdate,
): Promise<AppointmentRead> {
  const res = await apiFetch(`/api/appointments/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  })
  if (!res.ok) {
    const err = (await res.json()) as { detail?: string }
    throw new Error(typeof err.detail === 'string' ? err.detail : 'Failed to update appointment')
  }
  return res.json() as Promise<AppointmentRead>
}

export async function cancelAppointment(id: number): Promise<void> {
  const res = await apiFetch(`/api/appointments/${id}`, { method: 'DELETE' })
  if (!res.ok) throw new Error('Failed to cancel appointment')
}
